<template>

  <span class="print-view">
    <div class="btn-group float-right">
        <vs-button class="mx-1 my-1" type="border" @click="onClickPrint">Print & Download</vs-button>
    </div>
    <page id="printDiv" size="A4">
       <div class="vx-row mb-0">
            <div class="vx-col w-full">

              <vs-table :noDataText="''">
                <template slot="thead">
                  <vs-th width="25%"></vs-th>
                  <vs-th width="25%"></vs-th>
                  <vs-th width="20%"></vs-th>
                  <vs-th width="30%"></vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr class="content-start">
                    <vs-td>
                      <img
                           src="@/assets/images/logo/its_logo_horizontal.png" alt="ITS Logo" class="mx-auto" style="width: 80%; max-width: 200px">
<!--                      <img v-if="themeMode === 'dark'"-->
<!--                           src="@/assets/images/logo/ITS-logo-icon-horizontal-reversed.png" alt="ITS Logo" class="mx-auto" style="width: 80%; max-width: 200px">-->
                    </vs-td>
                    <vs-td class="content-start">
                      <h5 class="mb-2">Cutomer</h5>
                      {{ orderDetails.customer ? orderDetails.customer.company_name : orderDetails.customer_lead.company_name }} <br>
                      {{ orderDetails.customer ? orderDetails.customer.account_number : orderDetails.customer_lead.code }}
                    </vs-td>
                    <vs-td class="content-start">
                      <h5 class="mb-2	">Order Date</h5>
                      {{ __dateTimeFormatter(orderDetails.created_at) }}
                    </vs-td>
                    <vs-td class="mr-8">
                      <h5 class="mb-2">Address</h5>
                      {{ orderDetails.line1 }} <br v-if="orderDetails.line1">
                      {{ orderDetails.line2 }} <br v-if="orderDetails.line2">
                      {{ orderDetails.line3 }} <br v-if="orderDetails.line3">
                      {{ orderDetails.town_state }} <br>
                      {{ orderDetails.post_code }} <br>
                      {{ orderDetails.country }} <br>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              </div>
            </div>
       <div class="vx-row mt-0">
            <div class="vx-col w-full">

              <vs-table :data="sample_items" stripe>
                <template slot="thead">
                  <vs-th width="20%">FORMULATION CODE</vs-th>
                  <vs-th width="20%">FORMULATION NAME</vs-th>
                  <vs-th width="20%">QUANTITY (GRAMS)</vs-th>
                  <vs-th width="20%">PRICE PER UNIT (GBP/KG)</vs-th>
                  <vs-th width="20%">NET VALUE (GBP)</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :ref="`table_row_${indextr}`" :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td colspan="3" v-if="tr.type === 'sub'">

                      <vs-table class="mx-16 my-8" :data="tr.rm_items">

                        <template slot="header">
                          <h5 class="mb-4">Formulations breakdown</h5>
                        </template>

                        <template slot="thead">
                          <vs-th width="10%">PRODUCT CODE</vs-th>
                          <vs-th width="15%">PRODUCT NAME</vs-th>
                          <vs-th width="10%">QUANTITY (GRAMS)</vs-th>
                          <vs-th width="5%">SOL</vs-th>
                          <vs-th width="5%">HALAL</vs-th>
                          <vs-th width="10%">KOSHER</vs-th>
                        </template>

                        <template slot-scope="{data}">
                          <vs-tr :key="index_rm_item" v-for="(tr_item, index_rm_item) in data">

                            <vs-td>
                              <span v-if="tr_item.company_product_code"> {{ tr_item.category }}-{{ tr_item.company_product_code }} </span>
                              <span v-if="tr_item.formulation_code"> {{ tr_item.formulation_code }} </span>
                            </vs-td>

                            <vs-td :data="tr_item.company_product_name">
                              {{ tr_item.company_product_name || '' }}
                            </vs-td>

                            <vs-td :data="tr_item.quantity_kg">
                              {{ Number(tr_item.quantity_kg).toFixed(1) }}
                            </vs-td>

                            <vs-td :data="tr_item.dissolvable">
                              {{ tr_item.dissolvable === 'Yes' ? 'S' : '' }}
                            </vs-td>

                            <vs-td :data="tr_item.halal_suitable">
                              {{ suitableOrCertified(tr_item.halal_suitable, tr_item.halal_certified) }}
                            </vs-td>

                            <vs-td :data="tr_item.kosher_suitable">
                              {{ suitableOrCertified(tr_item.kosher_suitable, tr_item.kosher_certified) }}
                            </vs-td>

                          </vs-tr>
                        </template>

                      </vs-table>

                    </vs-td>

                    <vs-td class="font-bold text-lg" v-if="tr.type === 'main'" :data="data[indextr].formulation_code">
                      {{ data[indextr].formulation_code }}
                    </vs-td>

                    <vs-td class="font-bold text-lg" v-if="tr.type === 'main'" :data="data[indextr].name">
                      {{ data[indextr].name }}
                    </vs-td>

                    <vs-td class="font-bold text-lg" v-if="tr.type === 'main'" :data="data[indextr].quantity">
                      {{ data[indextr].quantity }}
                    </vs-td>

                    <vs-td class="font-bold text-lg" v-if="tr.type === 'main'" :data="data[indextr].price">
                      {{ Number(data[indextr].price).toFixed(2) }}
                    </vs-td>

                    <vs-td class="font-bold text-lg" v-if="tr.type === 'main'" :data="data[indextr].quantity">
                      {{ calculateNetValue(data[indextr]) }}
                    </vs-td>

                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
    </page>
  </span>

</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'

const CustomerRepository = RepositoryFactory.get('customer')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import Calculations from '@/mixins/Calculations'
import UpdateCustomerSampleOrderPopUp from '@/components/popups/customer/sample-orders/UpdateCustomerSampleOrderPopUp'
import GeneratePdfSampleOrderPopUp from "@/components/popups/customer/sample-orders/GeneratePdfSampleOrderPopUp";
import $ from 'jquery'

export default {
  name: "SampleOrderDetailsView",
  components: {
    UpdateCustomerSampleOrderPopUp,
    GeneratePdfSampleOrderPopUp
  },
  data: function () {
    return {
      orderDetails: {},
      id: '',
      dataLoaded: false,
      sample_items: [],
    }
  },
  mixins: [SuccessMessage, ErrorMessages, Calculations],
  async mounted() {
    this.id = this.$route.params.id
    await this.getSampleOrderDetails()
  },
  computed: {
    themeMode: {
      get ()    { return this.$store.state.theme },
      set (val) { this.$store.dispatch('updateTheme', val) }
    },
  },
  methods: {
    onClickBack() {
      if (this.$route.query.back_customer) {
        this.$router.push({path: `/pages/manage-nimble/customers/${this.$route.query.back_customer}?step=7`})
      } else {
        this.$router.push({path: `/pages/sample-orders`})
      }
    },
    async refreshData() {
      this.getSampleOrderDetailsView()
    },

    async onClickStatusChangeConfirm(id, status, items) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Confirm',
        text: 'Are you sure you want to make this change?',
        accept: this.onChangeSampleOrderStatus,
        parameters: [id, status]
      })
    },
    async onChangeSampleOrderStatus(params) {
      await this.$vs.loading({
        container: '#sample-order-details-view',
        scale: 0.45
      })
      try {
        await CustomerRepository.changeSampleOrderStatus(params[0], params[1])
        this.showSuccessMessage('Status change successfully!')
        await this.getSampleOrderDetails()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#sample-order-details-view > .con-vs-loading')
    },
    async getSampleOrderDetails() {
      await this.$vs.loading()
      try {
        const {data} = (await CustomerRepository.getSampleOrder(this.id)).data
        this.orderDetails = data

        this.sample_items = []
        this.orderDetails.formulation_items.forEach((x) => {
          const rm_items = x.raw_material_items
          this.sample_items.push({ type: 'main', id: x.id,  formulation_code: x.formulation_code, name: x.name, quantity: x.quantity, price: x.price })
          // this.sample_items.push({ type: 'sub', rm_items: rm_items })
        })
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
      this.dataLoaded = true
    },
    calculateNetValue(item) {
      const quantityInKg = Number(item.quantity) / 1000;
      const unitPrice = Number(this.$options.filters.format_price(item.price, 1));
      return (quantityInKg * unitPrice).toFixed(2);
    },
    async getSampleOrderDetailsView() {
      await this.getSampleOrderDetails()
    },
    suitableOrCertified(suitable, certified) {
      let text = ''
      if (suitable === 'Yes') {
        text = text + ' S'
      }
      if (certified === 'Yes') {
        text = text + ' C'
      }
      return text
    },

    sampleOrderStatusColorFactory() {
      const colors = {
        1: '#f8961e',
        2: '#f9844a',
        3: '#f9c74f',
        4: '#43aa8b',
        5: '#219ebc',
        6: '#006d77',
        7: '#d62828',
        8: '#4895ef',
        9: '#3a0ca3',
        10: '#52b788',
        11: '#f72585'
      }
      return colors[this.orderDetails.status.id]
    },
    async onClickGeneratePdf() {
      await this.$refs.generatePdfSampleOrderPopUp.openPopup(this.orderDetails)
    },
    onClickPrint() {
      // let printContents = document.getElementById('printDiv').innerHTML;
      // let originalContents = document.body.innerHTML;
      // document.body.innerHTML = printContents;
      // window.print();
      // document.body.innerHTML = originalContents;
      window.print()
    },

  }
}
</script>

<style lang="scss">
page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
@media print {
  .print-view {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    .vs-con-table {
      .vs-con-tbody {
        overflow: hidden !important;
      }
    }

    #printDiv,
    #printDiv * {
      visibility: visible;
    }

    #printDiv {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}
</style>
